 
import {PRIVATE_KEY} from '@/common/fammter'
import JSEncrypt from 'jsencrypt';
import axios from 'axios'


export const isAfter12Hours = (targetDateTime) => {
    // 将目标时间字符串转换为Date对象
    // console.log(targetDateTime,currentDate)
    const targetDate = new Date(targetDateTime);
    // console.log(targetDate)

    // 计算8小时后的时间
    // const twelveHoursLater = new Date(targetDate.getTime() + 8 * 60 * 60 * 1000);

    // 获取当前时间
    const now = new Date();

    return now >= targetDate;
}


let stsPromise = null; // 请求锁
let checkInterval = null;

export const ossGet = () => {
  const stsData = JSON.parse(localStorage.getItem('oss'));
  console.log('stsData',stsData)
  // 定期检查缓存是否过期
  if (!checkInterval) {

    checkInterval = setInterval(() => {

      const cachedData = JSON.parse(localStorage.getItem('oss'));
      if (cachedData && isAfter12Hours(cachedData.expireDate)) {
        // 过期后重新获取 STS Token
        console.log('缓存已过期，重新请求 STS Token');
        refreshStsToken();
      }

    }, 60000); // 每隔 1 分钟检查一次
  }

  // 如果缓存存在且没有过期，直接返回缓存数据
  if (stsData && !isAfter12Hours(stsData.expireDate)) {
    return Promise.resolve(stsData);
  } else {
    // 缓存无效，重新获取 STS Token
    return refreshStsToken();
  }
};

export const refreshStsToken = () => {
// 如果已有请求在进行中，复用该请求
  if (stsPromise) {
    return stsPromise; // 返回正在进行的请求
  }

  stsPromise = new Promise((resolve, reject) => {
axios
    .get('/api/sys-token/aliYunSts', {
      params: { devices: 'WebSite' },
    })
    .then((res) => {
      if (res.data.code === 200) {
        // 解密返回的 secretData
        const data = decrypt4096(PRIVATE_KEY, res.data.data.secretData);


        // 返回解密后的数据
        return data;
      } else {
        return Promise.reject(res.data);
      }
    })
    .catch((error) => {
      // 请求失败，清除请求锁
      console.error('请求失败', error);
      return Promise.reject(error);
    })
    .finally(() => {
      // 无论成功或失败，释放请求锁
      stsPromise = null;
    });
   
  });

  return stsPromise;
}


export function arrayBufferToBase64(buffer) {
    let binary = '';
    const bytes = new Uint8Array(buffer);
    for (let i = 0; i < bytes.byteLength; i++) {
        binary += String.fromCharCode(bytes[i]);
    }
    return btoa(binary);
}

// 工具函数
export function base64ToArrayBuffer(base64) {
    const binaryString = atob(base64);
    const bytes = new Uint8Array(binaryString.length);
    for (let i = 0; i < binaryString.length; i++) {
        bytes[i] = binaryString.charCodeAt(i);
    }
    return bytes;
}

export function decrypt4096(privateKey, data) {
  return new Promise((resolve, reject) => {
    try {

      // 小程序中Base64解码
      const byteData = base64ToArrayBuffer(data);
      const decryptor = new JSEncrypt();
      
      // 设置私钥，需要处理PKCS#8格式
      decryptor.setPrivateKey(privateKey);
      
      // 由于RSA有长度限制，需要分段解密
    //   const dataView = new DataView(byteData);
      const chunkSize = 512; // 4096bit对应512字节
      let decryptedParts = [];
      
      for (let offset = 0; offset < byteData.byteLength; offset += chunkSize) {
        const end = Math.min(offset + chunkSize, byteData.byteLength);
        const chunk = byteData.slice(offset, end);
        
        // 将ArrayBuffer转换为Base64字符串进行解密
        const chunkBase64 = arrayBufferToBase64(chunk);
        const decryptedChunk = decryptor.decrypt(chunkBase64);
        
        if (decryptedChunk === false) {
          reject(new Error('RSA解密失败'));
          return;
        }
        
        decryptedParts.push(decryptedChunk);
      }
      
      // 合并所有解密后的部分
      const finalResult = decryptedParts.join('');
      localStorage.setItem('oss', JSON.stringify({
        ...JSON.parse(finalResult)
      }));

      resolve(finalResult);
      
    } catch (error) {
      console.error('解密错误:', error);
      reject(error);
    }
  });
}

